import { createApiInstance, API_BASE_URL } from './axiosConfig';
import { JsonFile, CreateFileRequest, UpdateFileRequest } from '../types';

export class JsonFileService {
  private api = createApiInstance(`${API_BASE_URL}/json-files`);

  setAuthToken(token: string): void {
    this.api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }

  removeAuthToken(): void {
    delete this.api.defaults.headers.common['Authorization'];
  }

  async getFiles(): Promise<string[]> {
    const response = await this.api.get('/');
    return response.data;
  }

  async getFile(filename: string): Promise<JsonFile> {
    const response = await this.api.get(`/${filename}`);
    return response.data;
  }

  async createFile(filename: string, content: any): Promise<JsonFile> {
    const request: CreateFileRequest = { content };
    const response = await this.api.post(`/${filename}`, request);
    return response.data;
  }

  async updateFile(filename: string, content: any): Promise<JsonFile> {
    const request: UpdateFileRequest = { content };
    const response = await this.api.put(`/${filename}`, request);
    return response.data;
  }

  async deleteFile(filename: string): Promise<void> {
    await this.api.delete(`/${filename}`);
  }
}

